import React, { useState } from "react";
import styled from "styled-components";
import { typographyMixin } from "../../typography";
import { StyleSheetManager } from "styled-components";
import isPropValid from "@emotion/is-prop-valid";

type UserNoticeProps = {
  display: boolean;
  type: "error" | "warning" | "info" | "success";
  msg: string;
};

const StyledUserNotice = styled.div<{ type: UserNoticeProps["type"]; hasChildren: boolean }>`
  border-radius: 0.3125rem;
  border-bottom: 0;

  .content > * {
    border: ${({ hasChildren }) => (hasChildren ? "2px solid" : "none")};
    border: 2px solid
      ${({ type }) => {
        switch (type) {
          case "error":
            return "#ffafaf";
          case "warning":
            return "#FEDB6A";
          case "info":
            return "#097aff";
          case "success":
            return "#34b632";
          default:
            return "#ffafaf";
        }
      }};
    border-radius: 0.3125rem 0.3125rem 0 0 !important;
  }
`;

const Message = styled.div<{ type: UserNoticeProps["type"]; hasChildren: boolean }>`
  ${typographyMixin}
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 2.125rem;
  padding: 0.5rem;
  border-radius: ${({ hasChildren }) => (hasChildren ? " 0 0 0.3125rem 0.3125rem" : "0.3125rem")};
  background: ${({ type }) => {
    switch (type) {
      case "error":
        return "#ffafaf";
      case "warning":
        return "#FEDB6A";
      case "info":
        return "#097aff";
      case "success":
        return "#34b632";
      default:
        return "#ffafaf";
    }
  }};
  color: #000;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export default function UserNotice({ display, type, msg, children }: React.PropsWithChildren<UserNoticeProps>) {
  const hasChildren = !!React.Children.count(children);
  if (!display && children) return <>{children}</>;

  return (
    <StyleSheetManager shouldForwardProp={isPropValid}>
      <StyledUserNotice type={type} hasChildren={hasChildren}>
        <div className="content">{children}</div>
        <Message type={type} hasChildren={hasChildren}>
          {msg}
        </Message>
      </StyledUserNotice>
    </StyleSheetManager>
  );
}
